import { Injectable } from '@angular/core'
import { fromEvent, merge, Observable, of } from 'rxjs'
import { map } from 'rxjs/operators'

@Injectable()
export class NetworkService {
  online$: Observable<boolean>

  constructor () {
    this.online$ = merge(
      of(navigator.onLine),
      fromEvent(window, 'online').pipe(map(() => true)),
      fromEvent(window, 'offline').pipe(map(() => false)),
    )
  }
}
